
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "app-configuracao-partner",
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      form: {
        tamanho_logo_principal: 180,
        tamanho_logo_secundaria: 180,
        tamanho_icone: 48,
        tamanho_icone_branco: 48,
      },
      totais: [],
      urlLogo: null,
      urlIcone: null,
      urlLogoSecundaria: null,
      urlIconeBranco: null,
      ulrFavIcon: null,
      objectUrls: {},
    };
  },
  directives: {
    mask,
  },
  computed: {
    ...mapGetters([
      "itsblocked",
      "idRevenda",
      "dadosRevenda",
      "isRevenda",
      "currentUser",
    ]),
    brandAssets() {
      return [
        {
          field: "logo_principal",
          sizeField: "tamanho_logo_principal",
          url: this.urlLogo,
          urlField: "urlLogo",
          label: "Logomarca principal",
          article: "a",
          location: "Telas de login, links e documentos",
          preview: "login",
          previewLabel: "Login / área pública",
          min: 40,
          max: 320,
          defaultSize: 180,
        },
        {
          field: "logo_secundaria",
          sizeField: "tamanho_logo_secundaria",
          url: this.urlLogoSecundaria,
          urlField: "urlLogoSecundaria",
          label: "Logomarca secundária",
          article: "a",
          location: "Rodapé de orçamentos, pedidos e outros links digitais",
          preview: "footer",
          previewLabel: "Rodapé dos links digitais",
          min: 40,
          max: 320,
          defaultSize: 180,
        },
        {
          field: "icone",
          sizeField: "tamanho_icone",
          url: this.urlIcone,
          urlField: "urlIcone",
          label: "Ícone",
          article: "o",
          location: "Menus compactos e atalhos",
          preview: "compact",
          previewLabel: "Área compacta",
          min: 16,
          max: 160,
          defaultSize: 48,
        },
        {
          field: "icone_branco",
          sizeField: "tamanho_icone_branco",
          url: this.urlIconeBranco,
          urlField: "urlIconeBranco",
          label: "Ícone branco",
          article: "o",
          location: "Cabeçalho do sistema (Header.vue)",
          preview: "header",
          previewLabel: "Cabeçalho do sistema",
          min: 16,
          max: 160,
          defaultSize: 48,
        },
        {
          field: "favicon",
          url: this.ulrFavIcon,
          urlField: "ulrFavIcon",
          label: "Favicon",
          article: "o",
          location: "Aba do navegador",
          preview: "browser",
          previewLabel: "Aba do navegador",
          min: 16,
          max: 64,
          defaultSize: 24,
        },
      ];
    },
  },
  async mounted() {
    if (!this.isRevenda) {
      this.$router.push({ name: "dashboard" });
    }
    await this.getDataInit();
  },
  beforeDestroy() {
    Object.keys(this.objectUrls).forEach((field) => {
      URL.revokeObjectURL(this.objectUrls[field]);
    });
  },

  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);

      const data = await this.$http.post(
        "/empresa/cofing-partner",
        this.currentUser.usuario_empresa.empresa.nivel_revenda
      );
      if (data.data) {
        this.form = data.data;
        this.brandAssets.forEach((asset) => {
          if (asset.sizeField && !this.form[asset.sizeField]) {
            this.$set(this.form, asset.sizeField, asset.defaultSize);
          }
        });
        this.urlLogo = data.data.logo_principal;
        this.urlIcone = data.data.icone;
        this.urlIconeBranco = data.data.icone_branco;
        this.ulrFavIcon = data.data.favicon;
        this.urlLogoSecundaria = data.data.logo_secundaria;
      }
      this.setLoading(false);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setBrandAsset(event, asset) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      if (this.objectUrls[asset.field]) {
        URL.revokeObjectURL(this.objectUrls[asset.field]);
      }

      const objectUrl = URL.createObjectURL(file);
      this.$set(this.objectUrls, asset.field, objectUrl);
      this.$set(this.form, asset.field, file);
      this[asset.urlField] = objectUrl;
    },
    getBrandAssetSize(asset) {
      if (!asset.sizeField) {
        return asset.defaultSize;
      }
      const size = Number(this.form[asset.sizeField]);
      if (!Number.isFinite(size)) {
        return asset.defaultSize;
      }
      return Math.min(asset.max, Math.max(asset.min, Math.round(size)));
    },
    normalizeBrandAssetSize(asset) {
      if (!asset.sizeField) {
        return;
      }
      this.$set(this.form, asset.sizeField, this.getBrandAssetSize(asset));
    },
    brandAssetStyle(asset) {
      const size = `${this.getBrandAssetSize(asset)}px`;
      return {
        width: size,
        maxWidth: asset.preview === "browser" ? size : "90%",
      };
    },
    async gravarConfiguracao() {
      this.setLoading(true);

      let configuracao = new FormData();

      if (
        this.form.logo_principal !== null &&
        this.form.logo_principal instanceof Blob
      ) {
        configuracao.append("logo_principal", this.form.logo_principal);
      }

      if (
        this.form.logo_secundaria !== null &&
        this.form.logo_secundaria instanceof Blob
      ) {
        configuracao.append("logo_secundaria", this.form.logo_secundaria);
      }

      if (
        this.form.icone_branco !== null &&
        this.form.icone_branco instanceof Blob
      ) {
        configuracao.append("icone_branco", this.form.icone_branco);
      }

      if (this.form.favicon !== null && this.form.favicon instanceof Blob) {
        configuracao.append("favicon", this.form.favicon);
      }

      if (this.form.icone !== null && this.form.icone instanceof Blob) {
        configuracao.append("icone", this.form.icone);
      }

      this.brandAssets
        .filter((asset) => asset.sizeField)
        .forEach((asset) => {
          this.normalizeBrandAssetSize(asset);
          configuracao.append(
            asset.sizeField,
            String(this.form[asset.sizeField])
          );
        });

      if (this.form.cor_primaria !== null) {
        configuracao.append("cor_primaria", this.form.cor_primaria);
      }

      if (this.form.cor_primaria_hover !== null) {
        configuracao.append("cor_primaria_hover", this.form.cor_primaria_hover);
      }

      if (this.form.cor_secundaria !== null) {
        configuracao.append("cor_secundaria", this.form.cor_secundaria);
      }

      if (this.form.host !== null) {
        configuracao.append("host", this.form.host);
      }

      if (this.form.mail_host !== null) {
        configuracao.append("mail_host", this.form.mail_host);
      }

      if (this.form.mail_port !== null) {
        configuracao.append("mail_port", this.form.mail_port);
      }

      if (this.form.mail_username !== null) {
        configuracao.append("mail_username", this.form.mail_username);
      }

      if (this.form.mail_password !== null) {
        configuracao.append("mail_password", this.form.mail_password);
      }

      if (this.form.mail_encryption !== null) {
        configuracao.append("mail_encryption", this.form.mail_encryption);
      }

      if (this.form.app_name !== null) {
        configuracao.append("app_name", this.form.app_name);
      }

      await this.$http
        .post("/empresa/create-configuracao-partner", configuracao)
        .then((result) => {
          if (result) {
            this.setLoading(false);
            this.$toast.success("Configuração atualizada com sucesso!");
          }
        });
      this.setLoading(false);
    },
  },
};
